module.exports = __webpack_public_path__ + "static/img/i116.02de81d5.png";